/**
 * @flow
 * @relayHash 9027f8d1e7f5d2aea909536790937829
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type checkoutAttributes_viewer$ref = any;
export type checkoutAttributes_QueryVariables = {| |};
export type checkoutAttributes_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: checkoutAttributes_viewer$ref,
  |},
|};
*/


/*
query checkoutAttributes_Query {
  viewer {
    ...checkoutAttributes_viewer
    id
  }
}

fragment checkoutAttributes_viewer on Viewer {
  company_types {
    edges {
      node {
        id
        name
      }
    }
  }
  representative_roles {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "checkoutAttributes_Query",
  "id": null,
  "text": "query checkoutAttributes_Query {\n  viewer {\n    ...checkoutAttributes_viewer\n    id\n  }\n}\n\nfragment checkoutAttributes_viewer on Viewer {\n  company_types {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  representative_roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "checkoutAttributes_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "checkoutAttributes_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "checkoutAttributes_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company_types",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanyTypeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanyTypeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CompanyType",
                    "plural": false,
                    "selections": v1
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "representative_roles",
            "storageKey": null,
            "args": null,
            "concreteType": "RepresentativeRoleConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RepresentativeRoleEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RepresentativeRole",
                    "plural": false,
                    "selections": v1
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'ff7d17e6ce4365c678dd5915825651b5';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/checkoutAttributes_Query.graphql.js